const get = (url, options = {}) =>
  fetch(url, options);

export default get;